export enum POSSIBLE_ACTIONS {
  AWARD = 'award',
  NEGOTIATE = 'negotiate',
  IGNORE = 'ignore',
  EDIT_QTY = 'edit-qty',
  EDIT_PRICE = 'edit-price',
}
